<template>
  <div>
    <PageHeader :title="title" :items="headerItems" />
    <div class="main">
      <div class="inner__style">
        <div class="d-flex align-items-center justify-content-end add__variety__parent">
          <div class="add__variety" @click="showModal = true">+ تنوع جدید</div>
        </div>
        <Table @selectedRow="tableRowSelected($event)" :fields="tableData.fields" :rows="tableData.rows" noNeedToChangeRoute />
      </div>
    </div>
    <b-modal id="addModal" centered hide-footer v-model="showModal" title="تنوع ها">
      <div class="mt-3 float-right w-100">
        <b-form-group>
          <b-form-checkbox-group v-model="selected" :options="options" name="varieties" stacked></b-form-checkbox-group>
        </b-form-group>
        <div class="d-flex align-items-center justify-content-end bModalBtnDiv">
          <div @click="showModal = false">
            <Button text="انصراف" btnClass="btn-border cancel" />
          </div>
          <Button @click.native="modalSubmit()" text="ثبت"  btnClass="ms-2 aprove btn-border" :loading="btnLoading" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import Table from '@/components/common/table/simpleTable/SimpleTable.vue'
import varietyDataProvider from '../../services/varieties'
import Button from '@/components/common/Button.vue'
export default {
  components: {
    PageHeader,
    Table,
    Button,
  },
  data() {
    return {
      showModal: false,
      btnLoading: false,
      selected: [], // Must be an array reference!
      options: [
        { text: 'رنگ', value: 0 },
        { text: 'سایز', value: 1 },
        { text: 'گارانتی', value: 2 },
      ],
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'مدیریت تنوع',
          active: true,
        },
      ],
      title: 'مدیریت تنوع',
      tableData: {
        fields: [
          {
            index: 1,
            order: 1,
            key: 'Index',
            label: '#',
            typeEnum: 0,
            type: 'Text',
            isCollection: false,
            statusColors: {},
          },
          {
            index: 5,
            order: 5,
            key: 'Count',
            label: 'موجودی',
            typeEnum: 0,
            type: 'Text',
            isCollection: false,
            statusColors: {},
          },
          {
            index: 6,
            order: 6,
            key: 'Price',
            label: 'قیمت فروش',
            typeEnum: 2,
            type: 'Price',
            isCollection: false,
            statusColors: {},
          },
          {
            index: 7,
            order: 7,
            key: 'IsAvailable',
            label: 'وضعیت',
            typeEnum: 5,
            type: 'Status',
            isCollection: false,
            statusColors: [{}, {}],
          },
        ],
        rows: [],
        filters: {},
      },
    }
  },
  methods: {
    tableRowSelected(payload) {
      
      if (payload.items[0].value === 'اندازه') {
        this.$router.push({ path: '/list/size' })
      } else if (payload.items[0].value === 'رنگ') {
        this.$router.push({ path: '/list/color' })
      } else {
        this.$router.push({ path: '/list/guarantee' })
      }
    },
    modalSubmit() {
      this.btnLoading = true
      varietyDataProvider
        .addVariety({
          propertyType: this.selected,
          categoryId: this.$route.params.id,
        })
        .then(res => {
          this.btnLoading = false
          this.getTableData()
          this.showModal = false
        })
    },
    getTableData() {
      varietyDataProvider
        .getVarietyTable({
          searchDto: {
            search: '',
            pageSize: 10,
            pageNumber: 1,
          },
          categoryId: this.$route.params.id,
        })
        .then(res => {
          this.tableData = res.data.data.tableData
        })
    },
    getVarietyData() {
      varietyDataProvider.getVarietyData({ categoryId: this.$route.params.id }).then(res => {
        res.data.data.propertyTypes.forEach(element => {
          this.selected.push(element.propertyType)
        })
      })
    },
  },
  mounted() {
    this.getTableData()
    this.getVarietyData()
  },
}
</script>

<style scoped lang="scss">
.main {
  background: #f8f8fb;
  border-radius: 8px;
}
.inner__style {
  background-color: white;
  padding: 23px;
}
.add__variety__parent {
  margin-bottom: 26px;
  margin-top: 3px;
}
.add__variety {
  background: #34c38f;
  border-radius: 30px;
  padding: 8px 35px;
  cursor: pointer;
  color: white;
}
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
::v-deep .custom-control-label {
  margin-right: 8px;
}
</style>
